import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import api from 'utils/api';

type Buoy = {
  id: number;
  location: string;
  locationFF: string;
};

type UseFetchBuoysResult = {
  buoys: Buoy[];
  isLoading: boolean;
  error?: Error | null;
};

export type EventType = {
  id: number | string;
  eventType: string;
};

type UseFetchEventTypesResult = {
  eventTypes: EventType[];
  isLoading: boolean;
  error?: Error | null;
};

export const useFetchBuoys = (): UseFetchBuoysResult => {
  const {
    data: buoys,
    isPending: isGetBuoysPending,
    error: getBuoysError
  } = useQuery<Buoy[]>({
    queryKey: ['ombak', 'buoys'],
    queryFn: () => api.get('/admin/buoys').then((res) => res.data),
    initialData: [],
    staleTime: 0
  });

  useEffect(() => {
    if (getBuoysError) {
      window.alert(getBuoysError.message);
    }
  }, [getBuoysError]);

  return {
    buoys,
    isLoading: isGetBuoysPending,
    error: getBuoysError
  };
};

export const useFetchEventTypes = (): UseFetchEventTypesResult => {
  const {
    data: eventTypes,
    isPending: isGetEventtypesPending,
    error: getEventTypesError
  } = useQuery<EventType[]>({
    queryKey: ['ombak', 'eventTypes'],
    queryFn: () => api.get('/admin/eventTypes').then((res) => res.data),
    initialData: [],
    staleTime: 0
  });

  useEffect(() => {
    if (getEventTypesError) {
      window.alert(getEventTypesError.message);
    }
  }, [getEventTypesError]);

  return {
    eventTypes,
    isLoading: isGetEventtypesPending,
    error: getEventTypesError
  };
};
